import { render, staticRenderFns } from "./questionDetail.vue?vue&type=template&id=68281e16"
import script from "./questionDetail.vue?vue&type=script&lang=js"
export * from "./questionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports